import React from 'react';

import style from './index.module.scss';

export default function Loader() {
	return (
		<div className={style.container}>
			<svg className={style.circular} height="50" width="50">
				<circle className={style.path} cx="25" cy="25" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
			</svg>
		</div>
	)
}
